<button
  mat-icon-button
  class="small-icon-button star-button"
  [disabled]="!state.params.allowEdit"
  *ngIf="(state.params.node.group && state.params.showGroupOnly) || !state.params.showGroupOnly"
  (click)="addStarred(); $event.stopPropagation()"
>
  <mat-icon *ngIf="!state.starred" class="fs-11" style="color: #9999">star_border</mat-icon>
  <mat-icon *ngIf="state.starred" class="fs-11" style="color: #f5b401">star</mat-icon>
</button>
